import { ContactDetails } from '../contact-details';

export type ContactPersonDetails = ContactDetails & {
    readonly sameDetailsAsFa: boolean;
};

export const defaultContactPersonDetails: ContactPersonDetails = { sameDetailsAsFa: false };
